import type { GuestState } from './GuestApi';

export function browserReady(source: Pick<typeof globalThis, 'RTCPeerConnection'> & { navigator?: Pick<Navigator, 'mediaDevices'> }): boolean {
  return typeof source.RTCPeerConnection === 'function' && typeof source.navigator?.mediaDevices?.getUserMedia === 'function';
}

export function guestStatus(state: GuestState): { label: string; detail: string; onAir: boolean } {
  switch (state) {
    case 'CONNECTED': return { label: 'ПІДКЛЮЧЕННЯ', detail: 'Захищений аудіоканал готується.', onAir: false };
    case 'BACKSTAGE': return { label: 'ЗА ЛАШТУНКАМИ', detail: 'Вас чує ведучий, але слухачі ще не чують.', onAir: false };
    case 'ON_AIR': return { label: 'В ЕФІРІ', detail: 'Ваш голос зараз чують слухачі.', onAir: true };
    case 'MUTED': return { label: 'МІКРОФОН ВИМКНЕНО', detail: 'Ведучий тимчасово вимкнув ваш мікрофон.', onAir: false };
    case 'DISCONNECTED': return { label: 'ВІДКЛЮЧЕНО', detail: 'Гостьову сесію завершено.', onAir: false };
  }
}

export function invitationToken(fragment: string): string | null {
  const value = fragment.startsWith('#') ? fragment.slice(1) : fragment;
  return /^gi1\.[A-Za-z0-9_-]{43}$/.test(value) ? value : null;
}
